export default function() {

  // Close assistant
  $('#AssistantContainer .Close').click(function() {
    $('#AssistantContainer').removeClass('open').addClass('closed');
  })

  // Expand assistant
  $('#AssistantContainer .Open').click(function() {
    $('#AssistantContainer').addClass('open').removeClass('closed');
    $('.AssistantForm').find('textarea').focus();
    $('#AssistantContent').scrollTop($('#AssistantContent')[0].scrollHeight);
  })

  // Add target blank to all links
  $('#AssistantContent a').attr('target', function(index, oldValue) {
    return '_blank'
  });

  // Search messages
  function delay(callback, ms) {
    var timer = 0;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  $('.suggested-search').on('click', function() {
    $('#assistant_message_content').val($(this).text());
    $(".SubmitMessage").click();
    $('#assistant_message_content').val('');
    $('#assistant_message_content').blur();
  })


  $('#search_messages').keyup(delay(function (e) {
    let accountUrl = $('body').attr('data-account-url');
    let threadId = $('#AssistantContainer').attr('data-thread-id');
    let url = '/' + accountUrl + '/assistants/threads/' + threadId + '/messages';
    let params = {};
    params['query'] = $(this).val();
    $.ajax({
      type: "GET",
      dataType: "script",
      timeout: 3000,
      url: url + '.js?' + $.param(params)
    });
  }, 500));

  // Scroll to bottom on page load
  $('#AssistantContent').scrollTop($('#AssistantContent')[0].scrollHeight);


}

